"use strict";

exports.__esModule = true;
exports.default = intersection;
var _getLength = _interopRequireDefault(require("./_getLength.js"));
var _contains = _interopRequireDefault(require("./contains.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// Produce an array that contains every item shared between all the
// passed-in arrays.
function intersection(array) {
  var result = [];
  var argsLength = arguments.length;
  for (var i = 0, length = (0, _getLength.default)(array); i < length; i++) {
    var item = array[i];
    if ((0, _contains.default)(result, item)) continue;
    var j;
    for (j = 1; j < argsLength; j++) {
      if (!(0, _contains.default)(arguments[j], item)) break;
    }
    if (j === argsLength) result.push(item);
  }
  return result;
}